import * as LABELS_ACTION_TYPE from './labelConstants';
import { Label, LabelUpdateChanges } from './labelTypes';
import { getNewTransactionId } from '../../client/utils/undoRedo/undoRedoTransactionManager';
import { getGlobalClientId } from '../uid/ClientIdInstance';

/**
 * Creates a label-specific id from a generated element id.
 */
export const getNewLabelId = (id: string = getGlobalClientId().getElementId()) =>
    `${LABELS_ACTION_TYPE.LABEL_ID_PREFIX}${id}`;

export const mergeLoadedLabels = (labels: Label[] = []) => ({
    type: LABELS_ACTION_TYPE.LABELS_LOAD_MERGE,
    labels,
});

export const replaceLoadedLabels = (labels: Label[] = []) => ({
    type: LABELS_ACTION_TYPE.LABELS_LOAD_REPLACE,
    labels,
});

export const setFullLabelFetchTimestamp = (timestamp: number = Date.now()) => ({
    type: LABELS_ACTION_TYPE.LABELS_SET_FULL_FETCH_TIMESTAMP,
    timestamp,
});

export const createLabel = (label: Label, transactionId: number = getNewTransactionId()) => ({
    type: LABELS_ACTION_TYPE.LABEL_CREATE,
    label,
    transactionId,
    sync: true,
});

export const recreateLabel = (label: Label, transactionId: number = getNewTransactionId()) => ({
    type: LABELS_ACTION_TYPE.LABEL_RECREATE,
    label,
    transactionId,
    sync: true,
});

export const updateLabel = (labelId: string, changes: LabelUpdateChanges) => ({
    type: LABELS_ACTION_TYPE.LABEL_UPDATE,
    labelId,
    changes,
    transactionId: getNewTransactionId(),
    sync: true,
});

export const deleteLabel = (labelId: string, elementIds: string[] = []) => ({
    type: LABELS_ACTION_TYPE.LABEL_DELETE,
    labelId,
    elementIds,
    transactionId: getNewTransactionId(),
    sync: true,
});

export const selectLabels = (labelId: string, elementId: string, selectedElementId: string = elementId) => ({
    type: LABELS_ACTION_TYPE.LABEL_SELECT,
    selectedLabel: { _id: labelId, elementId, selectedElementId },
});

export const deselectLabels = () => ({
    type: LABELS_ACTION_TYPE.LABEL_SELECT,
    selectedLabel: null,
});

export const labelRenameStart = (labelId: string) => ({
    type: LABELS_ACTION_TYPE.LABEL_RENAME_START,
    labelId,
});

export const labelRenameFinish = () => ({
    type: LABELS_ACTION_TYPE.LABEL_RENAME_FINISH,
});

export const markLabelsAsStale = () => ({
    type: LABELS_ACTION_TYPE.LABELS_MARK_STALE,
});
